function Bengali() {
  return <h1>Bengali</h1>;
}

export default Bengali;